import { BasePage2, LangTextV2 } from 'bambooo';
/**
 * BasePage
 *
 * MWPA base page on top of the bambooo v2 shell (AdminLTE 4). The wrapper,
 * navbar, sidebar and preloader are owned by the single {@link PageLoader}; a
 * page reaches them through {@link getWrapper} once the loader has been
 * injected (i.e. from {@link loadContent}, not the constructor).
 */
export class BasePage extends BasePage2 {
    /**
     * Constructor — wire the MWPA toast style (top-end, auto-dismiss) into the
     * base page's SweetAlert2 mixin (`this._toast`, used across pages).
     */
    constructor() {
        super({
            swal: {
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
            }
        });
        /**
         * page name
         * @protected
         */
        this._name = 'base';
        /**
         * on load table
         * @protected
         */
        this._onLoadTable = null;
        /**
         * A title requested before the page loader was injected (e.g. from a page
         * constructor). Applied once the loader is set.
         * @protected
         */
        this._pendingTitle = null;
    }
    /**
     * setPageLoader — inject the loader and flush a buffered title.
     * @param {IPageLoader2} loader
     */
    setPageLoader(loader) {
        super.setPageLoader(loader);
        if (this._pendingTitle !== null) {
            super.setTitle(this._pendingTitle);
            this._pendingTitle = null;
        }
    }
    /**
     * setTitle — set the content-header title. Buffers the value when called
     * before the page loader is available (e.g. from a page constructor).
     * @param {PageTitle} title
     */
    setTitle(title) {
        if (!this._pageLoader) {
            this._pendingTitle = title;
            return;
        }
        super.setTitle(title);
    }
    /**
     * Return the shared shell wrapper (from the page loader). Only valid after
     * the page loader was set (inside loadContent), not the constructor.
     * @protected
     * @returns {IWrapper2}
     */
    get _wrapper() {
        if (!this._pageLoader) {
            throw new Error('BasePage: page loader not set yet');
        }
        return this._pageLoader.getWrapper();
    }
    /**
     * getWrapper
     * @returns {IWrapper2}
     */
    getWrapper() {
        return this._wrapper;
    }
    /**
     * Add a page-action button to the navbar (top), replacing the old
     * LeftNavbarLink "+ add" placement. Re-created from loadContent on every
     * navigation (the page-action navbar area is cleared by the loader).
     * @param {string|LangTextV2} label
     * @param {string} iconClass e.g. 'fas fa-plus'
     * @param {() => void} onClick
     * @protected
     */
    addNavbarButton(label, iconClass, onClick) {
        const navbar = this._wrapper.getNavbar();
        if (!navbar) {
            return;
        }
        const nav = navbar.getPageActionNavbar();
        const li = jQuery('<li class="nav-item"/>').appendTo(nav.getElement());
        const a = jQuery(`<a class="nav-link" href="#"><i class="${iconClass} me-1"></i> </a>`).appendTo(li);
        if (typeof label === 'string') {
            // Wrap in a LangTextV2 so the button label is translatable too.
            new LangTextV2({ text: label }).appendTo(a);
        }
        else {
            label.appendTo(a);
        }
        a.on('click', (event) => {
            event.preventDefault();
            onClick();
        });
    }
    /**
     * Return the page content.
     * @returns {Content2}
     */
    getContent() {
        return super.getContent();
    }
    /**
     * loadContent
     */
    async loadContent() {
        // load content overwrite
    }
    /**
     * unloadContent
     */
    async unloadContent() {
        // unload content overwrite
    }
}
